module.exports = __webpack_public_path__ + "success.9a2b6ea36e2ad4937c4efe1574896588.svg";